import { FC, ReactNode } from 'react'

import ConfirmDialog from '../../../components/ConfirmDialog/ConfirmDialog'
import { UnsavedChangesGuard } from '../../hooks/useUnsavedChangesGuard'

// The backdrop passes its click event as the confirmation, so a confirmation is recognised by its data.
const discardAction = 'discard'

type DiscardChangesDialogProps = {
  guard: UnsavedChangesGuard
  title: ReactNode
  text: ReactNode
  discardText: ReactNode
  // For pages that also ask before dropping changes without leaving; `onClose` then decides what happens.
  open?: boolean
  onClose?: (discard: boolean) => void
}

/** Asks whether to drop unsaved changes while the guard holds a navigation, and proceeds or cancels it. */
export const DiscardChangesDialog: FC<DiscardChangesDialogProps> = ({ guard, title, text, discardText, open = guard.isBlocked, onClose }) => (
  <ConfirmDialog
    open={open}
    confirmDialogData={{ title, confirmText: text, actionText: discardText, destructiveAction: true, data: discardAction }}
    onClose={(confirmed) => {
      const discard = confirmed?.data === discardAction
      if (onClose) onClose(discard)
      else if (discard) guard.proceed()
      else guard.cancel()
    }}
  />
)
